@if ({ isEditInProgress: isEditInProgress$ | async, isEditAllowed:
isEditAllowed$ | async }; as vm) { @if (vm.isEditAllowed) {
<div
  class="present-value d-flex flex-column"
  [class.cursor-warning]="showWarningError$ | async"
  [class.editing]="vm.isEditInProgress"
  [disabled]="useBlur"
  atxClickOutside
  (clickOutside)="clickOutsideHandler()"
>
  @if (isMultiline$ | async) {
  <ng-container *ngTemplateOutlet="resizeTextArea"></ng-container>
  } @else {
  <label class="input-container">
    <span
      class="width-machine text-value"
      [class.hide-value]="vm.isEditInProgress"
      [innerHtml]="
        textControl.value
          | numberOrNoop
            : inputType === 'number' && !vm.isEditInProgress
            : this.numberFormat
      "
    ></span>
    <input
      [class.hide-value]="!vm.isEditInProgress"
      class="text-value"
      data-e2e="product-list-name"
      id="productListName"
      #inputControl
      [attr.type]="inputType"
      [required]="isRequired$ | async"
      [maxlength]="maxCharacters$ | async"
      [formControl]="textControl"
      [placeholder]="placeholder$ | async"
      (keydown)="isAllowedCharacter($event)"
      (keydown.enter)="submit(); inputControl.blur()"
      (focusin)="handleInputFocusIn($event)"
      (blur)="blurHandler()"
    />
    <ng-continer *ngTemplateOutlet="editIcon"></ng-continer>
  </label>
  } @if (vm.isEditInProgress) {
  <div class="action-buttons">
    <button
      class="btn mr-1"
      [class]="actionBtnClass"
      [disabled]="textControl.invalid"
      (click)="submit(); $event.stopPropagation()"
    >
      <fa-icon [icon]="['fas', 'check']" size="xs" class=""></fa-icon>
    </button>
    <button
      class="btn"
      [class]="actionBtnClass"
      (click)="cancel(); $event.stopPropagation()"
    >
      <fa-icon [icon]="['fas', 'xmark']" size="xs" class=""></fa-icon>
    </button>
  </div>
  }
</div>
@if ((showWarningError$ | async) && vm.isEditInProgress) {
<atx-alert class="error-alert text-nowrap" severity="WARNING">
  <span
    class="text-warning"
    i18n="productList|max characters list warning@@listMaxCharactersWarning"
    >You reached {{ maxCharacters$ | async }} characters limit</span
  >
</atx-alert>
} @if (textControl.errors?.required && textControl.dirty) {
<atx-alert class="error-alert text-nowrap" severity="WARNING">
  <span class="text-warning">{{ placeholder$ | async }}</span>
</atx-alert>
} } @else {
<span class="text-value">{{ textValue$ | async }}</span>
}
<ng-template #resizeTextArea>
  <label
    class="textarea-container"
    [attr.data-value]="textControl.value || (placeholder$ | async)"
  >
    <textarea
      #textareaControl
      [placeholder]="placeholder$ | async"
      [formControl]="textControl"
      [maxlength]="maxCharacters$ | async"
      [required]="isRequired$ | async"
      (focusin)="handleInputFocusIn($event)"
      (keydown.enter)="submit(); textareaControl.blur()"
      class="text-value"
      rows="1"
      (blur)="blurHandler()"
    ></textarea>
    <ng-continer *ngTemplateOutlet="editIcon"></ng-continer>
  </label>
</ng-template>
<ng-template #editIcon>
  <fa-icon [icon]="['fas', 'pen']" class="edit-icon text-muted"></fa-icon>
</ng-template>
}
